import { test, expect, equals } from "@benchristel/taste"

export type Atom<T> = Readonly<{
  generation: number
  value: T
}>

export function atom<T>(value: T): Atom<T> {
  return {
    value,
    generation: 0,
  }
}

export function updateAtom<T>(atom: Atom<T>, value: T): Atom<T> {
  return {
    value,
    generation: atom.generation + 1,
  }
}

export function latest<Data>(
  a: Atom<Data>,
  b: Atom<Data>,
  tiebreaker: (a: Data, b: Data) => boolean,
): Atom<Data> {
  if (a.generation > b.generation) return a
  if (b.generation > a.generation) return b
  return tiebreaker(a.value, b.value) ? a : b
}

function alphabetically(a: string, b: string) {
  return a < b
}

test("latest", {
  "compares atoms by contained value if they have the same generation"() {
    const a = { generation: 0, value: "a" }
    const b = { generation: 0, value: "b" }
    expect(latest(a, b, alphabetically), equals, { generation: 0, value: "a" })
    expect(latest(b, a, alphabetically), equals, { generation: 0, value: "a" })
  },

  "compares atoms by generation"() {
    const a = { generation: 0, value: "a" }
    const b = { generation: 1, value: "b" }
    expect(latest(a, b, alphabetically), equals, { generation: 1, value: "b" })
    expect(latest(b, a, alphabetically), equals, { generation: 1, value: "b" })
  },
})
